<template>
    <label :class="getclass"
    >{{xlabel}}</label>
</template>

<script>
import mixins from "@/mixin"
import { Dau } from "@store/dau"
export default {
  mixins: [mixins],
  props:{
      label:String,
      cols:Number
  },
  computed: {
      getclass() {
         return this.cols?"label_side col-"+this.cols:"label_top"   
      },
      xlabel() {
          return Dau.T(this.label);
      }

  }
}
</script>
<style lang="scss">
   label {
       margin: 1px 0 1px 0;
   }
</style>



// WEBPACK FOOTER //
// src/_eng/globals/dlabel.vue